import WebStoriesIcon from '@mui/icons-material/WebStories';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { action, observable, runInAction, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import moment from 'moment';
import React, { Fragment } from 'react';
import Modal from '../misc/Modal';
import { Minuta, Processo } from '../modelo';
import { VersaoMinutaDto } from '../modelo/dto/VersaoMinutaDto';
import MinutaService from '../services/MinutaService';
import DownloadVersaoMinuta from './DownloadVersaoMinuta';
import RestaurarMinutaArquivada from './RestaurarMinutaArquivada';
import RestaurarVersaoMinuta from './RestaurarVersaoMinuta';
import VisualizarVersaoMinuta from './VisualizarVersaoMinuta';

interface IPropsVersoesMinuta {
    processo?: Processo;
    minuta?: Minuta;
}


class VersoesMinuta extends React.Component<IPropsVersoesMinuta> {

    openModal = false;
    historicoMinuta: VersaoMinutaDto[] = [];

    historicoMinutaService = MinutaService;

    constructor(props) {
        super(props);

        makeObservable(this, {
            openModal: observable,
            historicoMinuta: observable,
            abrirModal: action,
            fecharModal: action
        });

        moment.locale('pt-BR');
    }

    abrirModal = async () => {
        const historico = await this.historicoMinutaService.listarVersoesMinuta(this.props.minuta.numero);
        runInAction(() => {
            this.historicoMinuta = historico;
            this.openModal = true;
        });
    };

    fecharModal = () => {
        this.openModal = false;
    };

    render() {
        return (
            <>
                {this.props.minuta?.cpfUltimaAlteracao &&
                    <Fragment>
                        <Tooltip
                            title={"Versões da minuta"}
                        >
                            <IconButton size='small' style={{ padding: "3px 3px 0px 3px" }} onClick={this.abrirModal}>
                                <WebStoriesIcon />
                            </IconButton>
                        </Tooltip>
                        <Modal
                            aberto={this.openModal}
                            fecharModal={this.fecharModal}
                            funcaoAcaoSecundaria={this.fecharModal}
                            labelAcaoSecundaria='Fechar'
                            titulo={this.props.processo ? "Histórico de Versões da Minuta de " + this.props.minuta.tipo.descricao + " do Processo " + this.props.processo.numeroProcesso : ''}
                            maxWidth='lg' fullWidth
                        >
                            <TableContainer style={{ maxHeight: '440' }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Data/Hora</TableCell>
                                            <TableCell>Visualizar</TableCell>
                                            <TableCell>Baixar</TableCell>
                                            <TableCell>Restaurar</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.historicoMinuta.map((historico, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell>{moment(historico.ultimaAlteracao).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                                    <TableCell>
                                                        <VisualizarVersaoMinuta versao={historico} minuta={this.props.minuta} processo={this.props.processo} />
                                                    </TableCell>
                                                    <TableCell>
                                                        <DownloadVersaoMinuta versao={historico} minuta={this.props.minuta} processo={this.props.processo} />
                                                    </TableCell>
                                                    <TableCell>
                                                        {index != 0 && this.props.minuta?.situacaoMinuta?.codigo <= 30 &&
                                                            <div className='divFlexRow'>
                                                                <RestaurarVersaoMinuta versao={historico} minuta={this.props.minuta} processo={this.props.processo} fechar={this.fecharModal} />
                                                            </div>
                                                        }
                                                        {this.props.minuta?.situacaoMinuta?.codigo == 65 &&
                                                            <div className='divFlexRow'>
                                                                <RestaurarMinutaArquivada minuta={this.props.minuta} processo={this.props.processo} fechar={this.fecharModal} />
                                                            </div>
                                                        }
                                                    </TableCell>

                                                </TableRow>
                                            )
                                        }
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Modal>
                    </Fragment>
                }
            </>
        );
    }
}

export default observer(VersoesMinuta);
